import React from "react"
import { Grid, Paper } from "@mui/material"
import { GpsFixed, Home } from "@mui/icons-material"
import { Box } from "@mui/system"

interface Props {
  useHomePickup: boolean
  setUseHomePickup: (useHomePickup: boolean) => void
  isHomeEnabled: boolean
}

const LOCATIONS = [
  {
    id: "home",
    title: "Pickup At Home",
    icon: <Home />,
  },
  {
    id: "point",
    title: "Meeting Point",
    icon: <GpsFixed />,
  },
]

const PickupLocationPicker = ({
  useHomePickup,
  setUseHomePickup,
  isHomeEnabled,
}: Props) => {
  const selectedId = useHomePickup ? "home" : "point"

  if (!isHomeEnabled) {
    setUseHomePickup(false)
    return null
  }

  return (
    <>
      <h3>Where would you like your lesson?</h3>
      <Grid container spacing={2}>
        {LOCATIONS.map((item) => {
          const enabled = isHomeEnabled || item.id !== "home"

          return (
            <Grid item key={item.id} xs={3}>
              <Paper
                onClick={() => enabled && setUseHomePickup(item.id === "home")}
                role="button"
                tabIndex={0}
                className={`
                  picker-block 
                  ${item.id === selectedId ? "selected" : ""}
                  ${enabled ? "enabled" : "disabled"}
                `}
                data-cy="pickup-location-block"
              >
                <Box display="flex">
                  <div style={{ marginRight: 10 }}>{item.icon}</div>
                  <h3 style={{ margin: 0 }}>{item.title}</h3>
                </Box>
              </Paper>
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}

export default PickupLocationPicker
